export default __webpack_public_path__ + "static/media/sklearn_genetic_opt.15b892ad.png";